module.exports = __webpack_public_path__ + "img/clear-24px.fffe2917.svg";